import "./contact.css";
import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";

const Contact = () => {
  const form = useRef();

  const [showThanks, setShowThanks] = useState(false)
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_pt6ygbx",
        "template_7ox3pji",
        form.current,
        "w3k91JeNanyOOKEZY"
      )
      e.target.reset()
      
        setShowThanks(true);
        setTimeout(() => {
          setShowThanks(false);
          setEmail('');
          setName('');
          setProject('');
      }, 2000);


  };


  const [project, setProject] = useState('');
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [error, setError] = useState('');
 
  const handleSubmit = (e) => {
     e.preventDefault();
 
     if (!email.trim()) {
       setError('Email can\'t be empty.');
       return;
     }
     if (!name.trim()) {
       setError('Name can\'t be empty.');
       return;
     }
     if (!project.trim()) {
       setError('Project can\'t be empty.');
       return;
     }
     setError('');
     sendEmail(e);
     // Handle the form submission here.
  };


  return (
    <section className="contact section" id="contact">
      <h2 className="section__title">Get in touch</h2>
      <span className="section__subtitle">Contact Me</span>

      <div className="contact__container container grid">
        <div className="contact__content">
          <h3 className="contact__title">Talk to me</h3>

          <div className="contact__info">
            <div className="contact__card">
              <i className="bx bx-mail-send contact__card-icon"></i>
              <h3 className="contact__card-title">Email</h3>
              <span className="contact__card-data">user@gmail.com</span>

              <a href="mailto:ka1263@fayoum.edu.eg" className="contact__button">
                Write me
                <i className="bx bx-right-arrow-alt contact__button-icon"></i>
              </a>
            </div>

            <div className="contact__card">
              <i className="bx bxl-whatsapp contact__card-icon"></i>
              <h3 className="contact__card-title">Whatsapp</h3>
              <span className="contact__card-data">+968-9790 9617 </span>

              <a
                href="https://api.whatsapp.com/send?phone=+96897909617&text=Hello, more information"
                className="contact__button"
              >
                Write me
                <i className="bx bx-right-arrow-alt contact__button-icon"></i>
              </a>
            </div>

            <div className="contact__card">
              <i className="bx bxl-instagram contact__card-icon"></i>
              <h3 className="contact__card-title">Instagram</h3>
              <span className="contact__card-data">@kabdulrahmann</span>

              <a
                href="https://instagram.com/kabdulrahmann"
                className="contact__button"
              >
                Write me
                <i className="bx bx-right-arrow-alt contact__button-icon"></i>
              </a>
            </div>
          </div>
        </div>
        <div className="contact__content">
          <h3 className="contact__title">Write me your project</h3>

          <form className="contact__form" ref={form} onSubmit={handleSubmit}>
            <div className="contact__form-div ">
              <label className="contact__form-tag">Mail</label>
              <input
                type="email"
                name="email"
                className="contact__form-input"
                placeholder="Insert your email"
                onChange={(e) => setEmail(e.target.value)}

              />
            </div>
            <div className="contact__form-div">
              <label className="contact__form-tag">Name</label>
              <input
                type="text"
                name="name"
                className="contact__form-input"
                placeholder="Insert your name"
                onChange={(e) => setName(e.target.value)}

              />
            </div>
            <div className="contact__form-div contact__form-area">
              <label className="contact__form-tag">Project</label>
              <textarea
              
                name="project"
                className="contact__form-input"
                cols="30"
                rows="10"
                placeholder="Write your project"
                onChange={(e) => setProject(e.target.value)}
              ></textarea>
              {error && <p className='error'>{error}</p>}
            </div>
            <button type="submit" value="Send" className="button button--flex">
              Send Message
              <i class="uil uil-message" style={{ "marginLeft": "10px" }}></i>
            </button> <span className={showThanks?"show-thanks":"hide-thanks"}>Thank You</span>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
